import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {QuickPresetForm} from '../../components/QuickPresetForm';

export function Create() {
  return (
    <SettingsTemplate
      header={{
        title: i18n.t('page.settings.labels.advertisingQuickPresets.create'),
        breadcrumbs: [
          {
            label: i18n.t('page.salesSettings.labels.advertising'),
            href: settingsRoutes.advertising,
          },
          {
            label: i18n.t('page.settings.labels.advertisementPlatform'),
            href: settingsRoutes.advertisingPlatforms,
          },
          {
            label: i18n.t('page.settings.labels.advertisingQuickPresets.title'),
            href: settingsRoutes.advertisingQuickPresets,
          },
        ],
      }}
      isCreating
      data-testid={testIds.settings.advertisingQuickPresetsCreate()}
    >
      <QuickPresetForm />
    </SettingsTemplate>
  );
}
